<!-- <div class="modal-header">
    <h3 class="modal-title">{{alertDialog.HeadingText}}</h3>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
        aria-hidden="true"></button>
</div>
<div class="modal-body">
    <div>
        <button class="btn btn-outline-primary btn-sm mr-1 mb-1 float-left" (click)="selectOption('blank')" >Copy to a blank template</button>
        <button class="btn btn-outline-primary btn-sm mr-1 mb-1 float-left" (click)="selectOption('notblank')">Copy with data</button>
        <button class="btn btn-sm bg-g-red float-right mb-1" [mat-dialog-close]="">Cancel</button>
    </div>
</div> -->

<div *ngIf="alertDialog.AlertMsg === 'Self'">
    <div class="modal-header d-flex align-items-center justify-content-between">
        <h3 class="modal-title"><strong>{{alertDialog.HeadingText}}</strong></h3>
        <button class="fa fa-times border-0 p-0" [mat-dialog-close]="" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <div>
            <div class="overflow-x" style="width: 100%;">
                {{alertDialog.BodyText}}
            </div>
            <div class="my-3 text-right">
                <button class="btn btn-outline-primary btn-sm mr-1" (click)="selectOption('yes')">Yes</button>
                <button class="btn btn-sm bg-g-red" [mat-dialog-close]="">No</button>
            </div>
            <p><strong>Note : </strong> If you would like to start a new self assessment on this Rule, use 'Copy' action from the Self Assessment page. You will only be able to copy if you are named on the self assessment.</p>
        </div>
    </div>
</div>

<div *ngIf="alertDialog.AlertMsg === 'Copy'">
    <div class="modal-header">
        <h3 class="modal-title"><strong>{{alertDialog.HeadingText}}</strong></h3>
        <button class="fa fa-times" [mat-dialog-close]=""
            style="float: right;cursor: pointer;background: none;border:none" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <div>
            <button class="btn btn-outline-primary btn-sm mr-1 mb-1 float-left" (click)="selectOption('blank')">Copy to
                a blank template</button>
            <button class="btn btn-outline-primary btn-sm mr-1 mb-1 float-left" (click)="selectOption('notblank')">Copy
                with data</button>
            <button class="btn btn-sm bg-g-red float-right mb-1" [mat-dialog-close]="">Cancel</button>
        </div>
    </div>
</div>

<div *ngIf="alertDialog.AlertMsg === 'Approved'">
    <div class="modal-header">
        <h3 class="modal-title"><strong>{{alertDialog.HeadingText}}</strong></h3>
        <button class="fa fa-times" [mat-dialog-close]=""
            style="float: right;cursor: pointer;background: none;border:none" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <div>
            <div class="overflow-x" style="width: 100%;">
                {{alertDialog.BodyText}}
            </div>
            <button class="btn btn-sm bg-g-red float-right mb-1" [mat-dialog-close]=""
                (click)="selectOption('no')">No</button>
            <button class="btn btn-outline-primary btn-sm mr-1 mb-1 float-right"
                (click)="selectOption('yes')">Yes</button>
        </div>
    </div>
</div>